import { LOGIN_SSO_MUTATION } from "../constants/graphql/authentication";
import * as Sentry from "@sentry/browser";

const loginSsoService = {
  login(token, platform, apollo, store) {
    store.dispatch("setHasSeenPopupSinceLogin", undefined);
    
    return apollo
      .mutate({
        mutation: LOGIN_SSO_MUTATION,
        variables: {
          token: token,
          platform: platform
        },
      })
      .then((result) => {
        return result;
      })
      .catch((error) => {
        return error;
      });
  },
  loginSuccess(testator, router, cookies, store) {
    const accessToken = testator.accessToken;
    const refreshToken = testator.refreshToken;
    const testatorId = testator.testatorId;
    const userId = testator.userId;
    const willCountry = testator.willCountry;

    cookies.remove("referralCode");

    store.dispatch("login", {
      accessToken,
      refreshToken,
      testatorId,
      userId,
      willCountry,
    });
    this.setSentryUser(userId);
    this.redirectToNext(router);
  },
  setSentryUser(userId) {
    Sentry.setUser({ id: userId });
  },
  redirectToNext(router) {
    if (router.currentRoute.query.redirect) {
      router.push(router.currentRoute.query.redirect);
    } else if (this.isAdminOrAdvisor) {
      router.push("/admin");
    } else {
      router.push("/overview");
    }
  },
};

export default loginSsoService;
